import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MarkdownModule } from 'ngx-markdown';
import { B2bUiSectionDiscoverModule } from '../b2b-ui-section-discover/b2b-ui-section-discover.module';
import { B2bUiSectionGaranteeModule } from '../b2b-ui-section-garantee/b2b-ui-section-garantee.module';
import { B2bUiBreadcrumbModule } from '../b2b-ui-breadcrumb/b2b-ui-breadcrumb.module';
import { PageSeoRoutingModule } from './page-seo-routing.module';
import { PageSeoComponent } from './page-seo.component';

@NgModule({
  declarations: [PageSeoComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MarkdownModule.forChild(),
    PageSeoRoutingModule,
    B2bUiSectionDiscoverModule,
    B2bUiBreadcrumbModule,
    B2bUiSectionGaranteeModule,
  ],
  exports: [],
})
export class PageSeoModule {}
